/* import __COLOCATED_TEMPLATE__ from './intl-split.hbs'; */
var _dec, _class, _descriptor, _descriptor2, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { htmlSafe } from '@ember/template';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import { splitNode } from '@square/dashboard-translations/utils/split-translation';

/**
## intl-split

Allows for interpolating HTML into a template.

### Example

```example
@title Basic usage

@controller-properties
{
  // These are the segments you would get with the template
  // `Text before the link [[#link]]First text in the link [[#strong]]text in the strong[[/strong]], final text in the link[[/link]] text after the link`
  segments: [
    { text: 'Text before the link ' },
    {
      key: 'link',
      content: [
        { text: 'First text in the link ' },
        { key: 'strong', content: [{ text: 'text in the strong' }] },
        { text: ', final text in the link'}
      ]
    },
    { text: ' text after the link' }
  ]
}

@hbs
{{#intl-split "translation.key" (hash name=this.name)  as |segment|~}}
  {{~#if (eq segment.key "link")~}}
    <a href="squareup.com">
      {{~#segment.content as |innerSegment|~}}
        {{~#if (eq innerSegment.key "strong")~}}
          <strong>
            {{~innerSegment.content~}}
          </strong>
        {{~/if~}}
      {{~/segment.content~}}
    </a>
  {{~/if~}}
{{~/intl-split}}
```

### Parameters
@param {String} translationKey The translation key that identifies the template.
@param {Object} [options=undefined] The options that get used for the translation.
@param {Boolean} [useIntlCountry=false] Whether to use intlCountry service instead of intl
*/

function htmlSafeHelper(segment) {
  if (segment.content) {
    return {
      key: segment.key,
      content: segment.content.map(htmlSafeHelper)
    };
  } else {
    return {
      text: htmlSafe(segment.text)
    };
  }
}
let IntlSplit = (_dec = computed('intl.t', 'intlCountry.t', 'options', 'translationKey', 'useIntlCountry'), _class = (_class2 = class IntlSplit extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "intlCountry", _descriptor2, this);
    _defineProperty(this, "tagName", '');
  }
  get segments() {
    const service = this.useIntlCountry ? this.intlCountry : this.intl;
    const translated = service.t(this.translationKey, this.options);
    return splitNode(translated).map(htmlSafeHelper);
  }
}, _defineProperty(_class2, "positionalParams", ['translationKey', 'options']), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intlCountry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "segments", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "segments"), _class.prototype), _class);
export { IntlSplit as default };